import React from "react";

// Do not import CSS, otherwise it will be rendered when the file is loaded, not rendered
// and will create a visual glitch.

const NotFoundPage = () => {
  // Hack to override the property only when this component is rendered.
  document.getElementById("root").style = "display: block";
  return (
    <div id="error-block">
      <link rel="stylesheet" href="/error_pages/error.css" />
      <img src="/error_pages/robot.svg" alt="Broken robot" />
      <h1>404 - Resource not found</h1>
      <p>Sorry! We couldn&lsquo;t find the resource you are looking for.</p>
    </div>
  );
};

export default NotFoundPage;
